import { useMemo } from "react"

import createContextFactory from "@/utils/factory"

import { useCustomProp } from "../../utils"

const { Provider: NavigationProvider, useContext: useNavigationContext } = createContextFactory(() => {
  const itemProps = useCustomProp('itemProps')

  return useMemo(() => ({
    itemProps,
  }), [itemProps])
})

export {
  useNavigationContext,
  NavigationProvider,
}
